import { useCallback, useEffect, useState } from 'react';
import Button from '../../../shared/button';
import { useForm } from 'react-hook-form';
import AverageRating from './AverageRating';
import {
  useGetCustomerExperienceAssistantManualMutation,
  useGetCustomerExperienceAssistantMutation,
  useGetHotelListQuery,
} from '../../../store/customer-experience/customerExperienceApi';
import LatestReviews from './LatestReviews';
import Select from '../../../shared/select';
import { useGetCurrentUserQuery } from '../../../store/user/userApi';
import { useNavigate } from 'react-router-dom';
import AddHotel from '../profile/AddHotel';

const CustomerExperienceAssistant = () => {
  const [lastUpdated, setLastUpdated] = useState<string>('');
  const navigate = useNavigate();
  const { data: user } = useGetCurrentUserQuery();
  const [customerExperience, { isLoading, data: customerExperienceData }] =
    useGetCustomerExperienceAssistantMutation();

  const [customerExperienceManual, { data: customerExperienceDataManual }] =
    useGetCustomerExperienceAssistantManualMutation();
  const { data: hotelList } = useGetHotelListQuery(user?.id || '', {
    skip: !user?.id,
  });
  const { register, handleSubmit, setValue, watch } = useForm<{ id: string }>();

  const getReviews = async () => {
    try {
      await customerExperienceManual({
        userId: user?.id || '',
        locationId: watch('id'),
      });
    } catch (e) {
      console.log({ e });
    }
  };

  useEffect(() => {
    if (watch('id')) {
      getReviews();
    }
  }, [watch('id')]);

  useEffect(() => {
    if (user?.id && hotelList?.length) {
      setValue('id', hotelList?.[0]._id);
      getReviews();
    }
  }, [user?.id, hotelList]);

  const hotels = hotelList?.map((hotel) => ({
    ...hotel,
    label: hotel.hotelName,
    value: hotel._id,
  }));

  const onSubmit = useCallback(
    async (data: { id: string }) => {
      console.log(data);
      try {
        await customerExperience({
          hotelName:
            [...(hotels || [])]?.find((hotel) => hotel.value === data.id)
              ?.hotelName || '',
          locationId: data.id,
          userId: user?.id || '',
        }).unwrap();
      } catch (e) {
        console.log({ e });
      }
    },
    [hotels]
  );

  const customerExperienceResponse =
    customerExperienceData || customerExperienceDataManual;

  useEffect(() => {
    if (customerExperienceDataManual?.reviews) {
      const currentDate = new Date(
        customerExperienceDataManual?.reviews[
          customerExperienceDataManual?.reviews?.length - 1
        ]?.updatedAt
      );
      const formattedDate = currentDate.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });
      setLastUpdated(formattedDate);
    }
  }, [customerExperienceDataManual]);

  const handleNavigateAddProfile = () => navigate('/profile');
  return (
    <div>
      <p className="text-[#858D9D] text-xs font-medium mb-2">
        Customer Experience Assistant
      </p>
      <div className="bg-white rounded-2xl py-3 px-5">
        {hotels?.length ? (
          <>
            <label
              htmlFor=""
              className="text-base text-saloon-details font-medium tracking-wide"
            >
              Select Hotel
            </label>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-row">
              <Select
                register={register('id')}
                placeholder="Select hotel"
                containerStyle="mb-1 w-full"
                options={hotels || []}
              />
              <div className="flex-col">
                <Button
                  type="submit"
                  loading={isLoading}
                  className="flex flex-row items-center bg-saloon-btn text-white py-2 px-6 rounded-lg text-sm h-10 ml-4 min-w-80 justify-center"
                  icon={
                    <img
                      alt="settings"
                      className="mr-2 w-4"
                      src="/assets/shared/reviewt.svg"
                    />
                  }
                  label="Run Customer Experience Assistant"
                />
                <p className="pl-6">
                  {lastUpdated ? `Last updated at: ${lastUpdated}` : ''}
                </p>
              </div>
            </form>
          </>
        ) : (
          <>
            <AddHotel />
          </>
        )}
      </div>
      {customerExperienceResponse && (
        <AverageRating
          customerExperienceAssistant={customerExperienceResponse}
        />
      )}
      {customerExperienceResponse?.reviews && (
        <LatestReviews
          reviews={customerExperienceResponse?.reviews}
          count={customerExperienceResponse?.metadata?.count}
        />
      )}
    </div>
  );
};

export default CustomerExperienceAssistant;
